var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center","wrap":""}},[_c('v-col',{staticClass:"login-form",attrs:{"cols":"12"}},[_c('LoginCard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }